import { PERMISSIONS, PermissionService } from '@auth';

export interface DefaultRouteConfig {
  path: string;
  permissions: PERMISSIONS[];
}

/**
 * Returns the first accessible route's path based on the provided configuration.
 * TO BE USED IN DEFAULT REDIRECT GUARD.
 * @param configs An array of route configurations.
 * @param fallback The fallback route if no configuration is accessible.
 * @param permissionService Service used to check user permissions.
 */
export function getDefaultRedirectPath(configs: DefaultRouteConfig[], fallback: string, permissionService: PermissionService): string {
  const accessibleRoute = configs.find((config) => config.permissions.some((permission) => permissionService.hasPermission(permission)));
  return accessibleRoute ? accessibleRoute.path : fallback;
}
